import { gql } from "@apollo/client";

export default gql`
  query getCustomerOwners($search: String, $pageNumber: Int!, $pageSize: Int!, $appStatus: String, $accountStatus: String, $isEmailVerified: Boolean, $packageName: String, $periodMode: String){
    getCustomerOwners(search: $search, pageNumber: $pageNumber, pageSize: $pageSize, appStatus: $appStatus, accountStatus: $accountStatus, isEmailVerified: $isEmailVerified, packageName: $packageName, periodMode: $periodMode){
        success
        data{
            docs{
                customerPerson{
                    _id
                    customer
                    type
                    status
                    firstName
                    lastName
                    profilePhoto
                    isEmailVerified
                    email
                    phone
                    language
                    timeZone
                    devices{
                        type
                        status
                        lastLoginTime
                        statusAwayTime
                    }
                    dateFormat
                    joinedConvLimit
                    joinedConvCount
                    signedTeams
                    notificationSettings{
                        conversationSound
                        messageSound
                        notificationSoundVolume
                        notificationCardEnabled
                        mobilePushNotifications
                        newUnassignedConversation{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newConversationAssignedToMe{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newMessagesInConversationsAssignedToMe{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newMessagesInUnassignedConversations{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        taskReminder{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newTableRecordAssignedToMe{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newCommentInAssignedTableRecord{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newPrivateChatMessage{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        newTeamChatMessage{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        importRecordsToTable{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        exportTableRecords{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        importContacts{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        exportContacts{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        noteMention{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        taskCommentMention{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        trackingDomainVerified{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        exportReport{
                            web
                            mobile
                            email
                            sound
                            loopScope
                        }
                        qpienAnnouncements{
                            web
                            mobile
                            email
                            whatsapp
                        }
                    }
                    isAcceptingCalls
                    canAccessPhoneCalls
                    isInCall
                    is2FAEnabled
                    hasPassword
                    archivedAt
                    hasAiAssistant
                    productTour{
                        mainCompletedAt
                        mainSkippedAt
                        boardsCompletedAt
                        welcomeVideoWatchedAt
                        modules
                    }
                }
                customer{
                    _id
                    phone
                    companyName
                    email
                    category
                    autoConversationAssignment
                    autoAssignmentType
                    autoConversationAssignmentTime
                    autoConversationAssignmentTimeUnit
                    photo
                    createdAt
                    customerFromChannel
                    country
                    package{
                        _id
                        name
                        type
                        price
                        feeCharged
                        paymentStatus
                        periodMode
                        periodCount
                        endDate
                        refreshDate
                        freeTrialExpiringDate
                        customer
                        createdAt
                        ipAddress
                        couponCode{
                            _id
                            customer
                            name
                            code
                            status
                            valueType
                            value
                            maxRedemptions
                            timesRedeemed
                            usageType
                            usageLimit
                            usageCount
                            expiredAt
                            createdAt
                            updatedAt
                        }
                        accountBalance
                        addOns{
                            _id
                            name
                            quantity
                            renewalType
                            price
                            cancelAtPeriodEnd
                            credits
                            nextCredits
                        }
                        paymentFromOtherChannel
                        features{
                            dashboard
                            inbox
                            inboxPrivateMessage
                            inboxBulkActions
                            inboxCustomViews
                            inboxMessageTranslation
                            contacts
                            contactsDynamicGroups
                            contactsMergeContacts
                            contactsImport
                            contactsExport
                            statistics
                            statisticsConversations
                            statisticsMessages
                            statisticsUsers
                            statisticsPerformance
                            statisticsSatisfactions
                            statisticsAbandonedCarts
                            statisticsCampaign
                            settings
                            settingsUsers
                            settingsUserRoles
                            settingsActions
                            settingsAuthentications
                            settingsApiKeys
                            settingsWebhooks
                            settingsTeams
                            settingsTags
                            settingsQuickAnswers
                            settingsAutoAssignment
                            settingsTeamGoals
                            settingsSlaPolicies
                            settingsTopics
                            settingsTopicsAutoFill
                            settingsCustomFields
                            settingsSurveys
                            channels
                            channelsLiveChat
                            channelsCustomChannel
                            channelsForm
                            channelsLiveChatRemoveQpienLogo
                            channelsEmail
                            channelsSms
                            channelsPhone
                            channelsWhatsAppWeb
                            channelsWhatsAppBusinessApi
                            channelsMetaWhatsAppBusinessApi
                            channelsTelegram
                            channelsFacebookDm
                            channelsFacebookComment
                            channelsInstagramDm
                            channelsInstagramComment
                            channelsTiktokDm
                            channelsTiktokComment
                            channelsMarketplace
                            campaignEngineV2
                            automation
                            automationFlowBots
                            teamChat
                            automationEcommerce
                            automationFlowBotsHttpRequest
                            automationFlowBotsStartFlow
                            channelsEcommerce
                            channelsPhoneCallRecord
                            channelsPhoneInboundCalls
                            channelsPhoneSurvey
                            channelsPhoneOutboundCalls
                            channelsPhoneTestToSpeech
                            channelsPhonelVR
                            statisticsConversationTags
                            ai
                            aiAnalysis
                            AiAgent
                            AiAssistant
                            AiClosingTag
                            AiClosingNote
                            AiClosingSurvey
                            AiStartFlow
                            AiStatistics
                            aiImageRecognition
                            aiHumanReplyLearning
                            bulkSharing
                            zohoIntegration
                            collageSharing
                            tasks
                            snooze
                            messageSchedule
                            channelsPhoneCallTranscripts
                            channelsPhoneCallAiAnalysis
                            removeEmailQpienLogo
                            tables
                            customReports
                            channelOwner
                            userActivity
                            autoAway
                        }
                        limits{
                            cPerson
                            cPersonRoles
                            person
                            whatsAppWeb
                            whatsAppBusiness
                            metaWhatsAppBusiness
                            liveChat
                            customChannel
                            form
                            facebook
                            email
                            instagram
                            tiktok
                            telegram
                            trendyol
                            hepsiburada
                            ebay
                            kaufland
                            pazarama
                            walmart
                            n11
                            teams
                            apiKeys
                            webhooks
                            inboxRules
                            flowBots
                            survey
                            message
                            amazon
                            aiAnswers
                            zoho
                            callMinutes
                            phone
                            aiAssistant
                            ticket
                            qpienShop
                            ikas
                            faprika
                            ticimax
                            tsoft
                            ideasoft
                            shopify
                            googleBusiness
                            slaPolicies
                            tables
                            tableRecords
                            customReports
                            operatorCredits
                        }
                        usages{
                            cPerson
                            cPersonRoles
                            person
                            whatsAppWeb
                            whatsAppBusiness
                            metaWhatsAppBusiness
                            liveChat
                            customChannel
                            form
                            facebook
                            email
                            instagram
                            tiktok
                            telegram
                            trendyol
                            hepsiburada
                            ebay
                            kaufland
                            pazarama
                            walmart
                            n11
                            teams
                            apiKeys
                            webhooks
                            inboxRules
                            flowBots
                            survey
                            message
                            amazon
                            aiAnswers
                            zoho
                            callMinutes
                            phone
                            aiAssistant
                            ticket
                            qpienShop
                            ikas
                            faprika
                            ticimax
                            tsoft
                            ideasoft
                            shopify
                            googleBusiness
                            slaPolicies
                            tables
                            tableRecords
                            customReports
                            operatorCredits
                        }
                        reChargeSettings{
                            limit
                            chargeAmount
                            isEnabled
                        }
                    }
                    timeZone
                    currency
                    isANewCustomer
                    isDummy
                    accountStatus
                    accountConfirmation
                    appStatus
                    language
                    allowConnect
                    is2FARequired
                    teamGoalTime
                    teamOnlineGoalTime
                    teamFirstResponseGoalTime
                    sendAutoSurvey{
                        status
                        time
                        closingMessage
                        surveyId
                        channels
                        tagRule
                        tags
                    }
                    closingNote{
                        isEnabled
                        autoFillWithAi
                        isCompletionRequired
                        customFields{
                            _id
                            name
                            label
                            description
                            type
                            listValues
                            conditions{
                                parentField
                                parentValues
                            }
                            visibleToCustomers
                            visibleToUsers
                            status
                            isDefault
                            customer
                            createdAt
                            updatedAt
                            mediaType
                        }
                    }
                    cPersonsAutoAwayTime
                    autoApproveSharingRequests
                    canManageOtherUserConversation
                    allowUnassignedTicket
                    twSubAccount{
                        sid
                        token
                        apiKeySid
                        apiKeySecret
                    }
                    onboarding{
                        channelConnected
                        teamInvited
                        accountCustomized
                        aiAgentTrained
                        mobileAppDownloaded
                        introVideoWatched
                        completedCount
                        totalCount
                        isVisible
                    }
                    partnerCode
                    signUpMethod
                }
            }
            totalDocs
            hasNextPage
            hasPrevPage
        }
        code
        message
    }
}
`
